import { getAmountInMinutesFromRange } from '../PartialSliderHelper';

/**
 * @typedef {typeof RequestStatus} IRequestStatus
 *
 * @typedef {{
 *  id: number;
 *  startDateTime: Date;
 *  endDateTime: Date;
 * }} ShiftRequestRange
 *
 * @typedef {{
 *  partialShift: { id: number };
 *  partialFromDate: Date;
 *  partialToDate: Date;
 *  status: IRequestStatus[keyof IRequestStatus];
 * }} PartialOffer
 *
 * @typedef {PartialOffer & {
 *  fromLabel: string;
 *  toLabel: string;
 * }} PartialOfferWithLabel
 *
 * @typedef {{ min: number; max: number }} SliderThresholds
 *
*/

/**
 * Will calculate the `min` and `max` based on the already taken partial ranges
 * @param {ShiftRequestRange} shiftRequestRange The whole shift spectrum that can be requested
 * @param {PartialOfferWithLabel[]} partialShiftOffers
 */
export const getSliderThresholds = (shiftRequestRange, partialShiftOffers) => {
    /** @type {Date} */
    let min = shiftRequestRange.startDateTime;

    /** @type {Date} */
    let max = shiftRequestRange.endDateTime;

    const { startDateTime, endDateTime } = shiftRequestRange;
    const maxMinuteInRange = getAmountInMinutesFromRange(startDateTime, endDateTime);

    /** @type {SliderThresholds} */
    const thresholds = {
        min: 0,
        max: maxMinuteInRange,
    };

    const isRangesSet = !!(Object.keys(shiftRequestRange || {}).length && partialShiftOffers?.length);

    // TODO - 02-21 - Deivid : Consider partial offer lengths > 1 in thresholds
    if (!isRangesSet || partialShiftOffers.length !== 1) {
        return thresholds;
    }

    const [partialOffer] = partialShiftOffers;

    const {
        partialFromDate: startPartial,
        partialToDate: endPartial,
    } = partialOffer;

    const startPartialTime = partialOffer.partialFromDate.getTime();
    const endPartialTime = partialOffer.partialToDate.getTime();
    const startDateTimeTime = startDateTime.getTime();
    const endDateTimeTime = endDateTime.getTime();

    if (startPartialTime > startDateTimeTime) {
        max = (startPartialTime > endDateTimeTime ? endDateTime : startPartial);
    } else if (startPartialTime === startDateTimeTime) {
        min = (endPartialTime > endDateTimeTime ? 0 : endPartial);
        max = endDateTime;
    } else { // startPartialTime is < than startDateTimeTime
        min = 0;
        max = endDateTime;
    }

    thresholds.min = getAmountInMinutesFromRange(startDateTime, min);
    thresholds.max = getAmountInMinutesFromRange(startDateTime, max);

    return thresholds;
};
